document.addEventListener("DOMContentLoaded", function () {
	const counters = document.querySelectorAll('.number-item__value');

	const animateCounter = (el) => {
		const startValue = parseInt(el.getAttribute("data-start")) || 0;
		const endValue = parseInt(el.getAttribute("data-target"));
		const duration = 750;
		const frameRate = 60;
		const totalSteps = Math.round(duration / (1000 / frameRate));
		const step = (endValue - startValue) / totalSteps;
		let current = startValue;

		const interval = setInterval(() => {
			current += step;
			if ((step > 0 && current >= endValue) || (step < 0 && current <= endValue)) {
				el.textContent = endValue.toLocaleString();
				clearInterval(interval);
			} else {
				el.textContent = Math.round(current).toLocaleString();
			}
		}, 1000 / frameRate);
	};

	const observer = new IntersectionObserver((entries, obs) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				animateCounter(entry.target);
				obs.unobserve(entry.target);
			}
		});
	}, {
		threshold: 0.6
	});

	counters.forEach(counter => {
		observer.observe(counter);
	});
});
